import styled from 'styled-components';
import {
  Nav,
  NavLink as NavLinkBase,
  Collapse,
  Popover as ActionPopover,
  UncontrolledPopover,
} from 'reactstrap';

import { colors, fonts, fontSizes, device } from 'shared/defaultTheme';
import { Modal } from 'shared/components/modal/Modals';

const NavHome = styled(Nav)`
  border-bottom: 1px solid ${colors.pattens};
  margin-top: 26px;
`;

const NavLink = styled(NavLinkBase)`
  border: none !important;
  border-bottom: ${({ selected }) => (selected ? '2px' : '1px')} solid ${({ color }) => color} !important;
  color: ${colors.black};
  cursor: pointer;
  font-family: ${fonts.default};
  font-size: ${fontSizes.xxs}px;
  font-weight: ${({ selected }) => (selected ? 'bold' : '500')};
  letter-spacing: 0;
  line-height: 12px;
  text-align: center;
  text-transform: uppercase;
`;

const UploadedImage = styled.div(({ imageSrc }) => ({
  background: `url('${imageSrc}')`,
  backgroundPosition: 'center',
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  height: '100%',
}));

const CustomCollapse = styled(Collapse)`
  height: 0 !important;
  width: 207px;
  float: right;
  position: relative;
  top: -2rem;
`;

const CustomCollapseBody = styled.div`
  border-radius: 4px;
  background-color: ${colors.white};
  box-shadow: 0 0 4px 0 ${colors.lightSilverTwo};
  height: auto;
`;

const OptionMenu = styled.section`
  width: 100%;
  cursor: pointer;
  height: ${({ height }) => height ?? 34}px;
  padding-left: 14px;
  padding-right: 5px;
  padding-top: 4px;
  &:hover {
    background-color: ${colors.whiteSmoke};
  }
`;

const TableHeader = styled.div`
  align-items: flex-end;
  display: flex;
  flex-direction: row;
  height: 100%;
  justify-content: start;
`;

const TableHeaderText = styled.span`
  color: ${colors.black};
  font-family: ${fonts.default};
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 14px;
  text-transform: uppercase;
`;

export const TableBodyText = styled.div`
  white-space: nowrap;
  width: 200px;
  p {
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;

const Popover = styled(ActionPopover)`
  .popover {
    border: none;
    box-shadow: 0 0 4px 0 #d6d8d9;
    min-width: 80px;
    top: ${({ top }) => top} !important;
    left: ${({ left }) => left} !important;
    ${({ width }) => (width ? `width: ${width}px;` : '')}
    .popover-body {
      padding: 0;
    }
  }
  .popover .arrow::before,
  .popover .arrow::after {
    border-style: none;
  }
`;

const GroupFieldWrapper = styled.div`
  background-color: ${colors.whiteSmoke};
  border: 1px solid ${colors.pattens};
  border-radius: 4px;
  height: auto;
  max-height: fit-content;
  min-height: 98px;
  padding: 8px 16px 36px 8px;
  width: 100%;
  overflow: auto;

  .form__form-group-field {
    background-color: ${colors.white};
  }
  .list-field {
    background-color: ${colors.white};
  }
`;

const PopoverSort = styled(UncontrolledPopover)`
  .popover {
    width: auto;
    border: none;
    box-shadow: 0 0 4px 0 #d6d8d9;
    .popover-body {
      padding: 0;
      width: 191px;
      text-align: center;
      .custom-checkbox .custom-control-label::before {
        border-radius: 0;
      }
      .custom-control-label::before {
        height: 14.05px;
        width: 14px;
      }
      .filter-span-client {
        position: relative;
        left: -2px;
        top: -1px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        flex: 1 1 auto;
        text-align: left;
      }
      .filter-field-container {
        overflow: auto;
        height: auto;
        max-height: 350px;
      }
    }
  }
  .popover .arrow::before,
  .popover .arrow::after {
    border-style: none;
  }
  .label-icon-sort {
    height: 25px;
  }
`;

const Information = styled.div`
  a {
    cursor: pointer;
    font-family: ${fonts.default};
    font-size: ${fontSizes.md}px;
    letter-spacing: 0;
    line-height: 19px;
    &:hover {
      text-decoration: underline !important;
    }
  }
`;

const InformationModal = styled(Modal)`
  top: 15%;
  .modal-content {
    border-radius: 4px;
  }
  .modal-header {
    border: 0;
    height: 36px;
    padding-top: 20px;
    padding-bottom: 0;

    svg {
      fill: ${colors.suvaGrey} !important;
      height: 18px !important;
      width: 18px !important;
    }
  }
  .modal-body {
    padding: 0 27px;
    padding-bottom: 26px;
    .row-title {
      border-bottom: 1px solid ${colors.spanishGray};
      padding: 0;
      padding-bottom: 6px;
      width: 100%;
      margin-left: -3px;
      h3 {
        color: ${colors.black};
        font-family: ${fonts.default};
        font-size: ${fontSizes.xlg}px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 24px;
      }
    }
    .information-message {
      font-family: ${fonts.default};
      font-size: ${fontSizes.md}px;
      letter-spacing: 0;
      line-height: 24px;
    }
    .action-information {
      display: flex;
      justify-content: flex-end;
      margin-top: 15px;
      button {
        height: 40px;
        width: 110px;
      }
    }
  }
`;

const ContactsModal = styled(Modal)`
  .button-section {
    margin-top: 50px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
  }
  #csvInput {
    display: none;
  }
  .input-file {
    border: 0 solid;
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 #D6D8D9;
    display: inline-block;
    padding: 6px 12px;
    cursor: pointer;
    font-family: MTTMilano;
    font-weight: bold;
    width: 70%;
  }
  .input-header{
    display: flex;
    justify-content: space-between;
  }
  .input-icon {
    width: 20px;
    height: 17px;
  }
  .delete-button {
    background-color: transparent;
    border: none;
    outline: none;
    font-family: MTTMilano;
    padding: 0;
  }
  .input-file-div {
    display: flex;
    justify-content: center;
  }
  .file-name {
    display: block;
    font-weight: normal;
  }
  .statistic-section {
    display: flex;
    justify-content: center;
    gap: 15px;
    padding: 30px 0 15px
  }
  .styled-statistic {
    display flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: ${colors.whiteSmoke};
    width: 198px;
    height: 180px; 
    border-radius: 4px;
    position: relative;
  }
  .statistic-item {
    height: 35px;
    width: 189px;
    font-family: ${fonts.default};
    font-size: 26px;
    font-weight: bold;
    letter-spacing: 0;
    text-align: center;
    margin: 0;
  }
  .error-list-main {
    margin: auto;
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: 80%;
  }
  .error-list-header-div {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid black;
    margin-bottom: 10px;
  }
  .error-list-header {
    font-family: ${fonts.default};
    font-weight: bold;
    font-size: 14px;
  }
  .ul-error-list {
    padding: 0;
  }
  .error-list-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px; 
    font-family: ${fonts.default};
    font-weight: bold;
    font-size: 14px;
    border-top: 1px solid ${colors.whiteSmoke};
  }
  .error-list-item-title {
    margin: 0;
  }
  .error-list-item:last-child {
    border-bottom: 1px solid ${colors.whiteSmoke};
  }
  
  .error-text {
    color: ${colors.venetianRed}
  }
  .w-40 {
    width: 40%;
  }
  .user-icon {
    width: 15px;
    height: 18px;
    margin: 0 5px;
  }
  .statistic-title {
    font-family: MTTMilano;
    font-size: 20px;
  }
  .statistic-icon {
    width: 25px;
    height: 28px;
  }
  .dividing-line-statistic{
    background-color: ${colors.black};
    width: 55px;
    margin: 7px
  }
  .error-info {
    position: absolute;
    bottom: 10px;
    background: none;
    border: none;
    outline: none;
    padding: 0;
    margin: 0;
    height: 13px;
    width: 121px;
    color: #4F92E0;
    font-family: ${fonts.default};
    font-size: 14px;
    text-align: center;
    text-decoration: underline;
  }
  .df {
    display: flex;
    align-items: center;
  }
  .styled-button {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: solid black 1px;
    border-radius: 4px;
    height: 181px;
    width: 291px;
    &:hover {
      background-color: ${colors.whiteSmoke};
      cursor: pointer;
    }
    svg {
      height: 33px;
      width: 29px;
      margin: 5px;
    }
  }
  .button-title {
    font-family: ${fonts.default};
    font-size: 20px;
    font-weight: bold;
  }
  .title-modal-contacts {
    text-align: left !important;
  }
  .button-description {
    max-width: 80%;
  }
  .button-section2 {
    display: flex;
    justify-content: flex-end;
    gap 10px;
    margin-top: 20px;
  }
  .modal-content {
    border-radius: 4px;
    width: 90%;
  }
  .dividing-line {
    background-color: ${colors.suvaGrey};
    width: 100%;
  }
  .dividing-line-block {
    background-color: ${colors.black};
    height: 1px;
    width: 80%;
  }

  @media ${device.sm} {
    top: 4%;
    .modal-content {
      width: 100%;
    }
  }

  @media ${device.md} {
    top: 4%;
  }
  @media ${device.lg} {
    top: 4%;
  }
  @media ${device.xl} {
    top: ${({ top }) => top};
  }
  .modal-header {
    border: 0;
    height: 36px;
    padding-top: 20px;
    padding-bottom: 0;

    svg {
      fill: ${colors.suvaGrey} !important;
      height: 18px !important;
      width: 18px !important;
    }
  }
  .modal-body {
    padding: 0 1.7rem 1.7rem 1.7rem;
    .title-modal-contacts {
      text-align: center;
      color: ${colors.black};
      font-family: ${fonts.default};
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 15px;
      letter-spacing: 0;
      line-height: 24px;
    }
    .warning-container {
      padding: 0.5rem;
      margin: 1rem 0;
    }
    .warning-icon-contacts {
      color: red;
      fill: ${colors.indochine};
      width: 100%;
      margin-bottom: 1rem;
    }
    .warning-text-contacts {
      display: flex;
      text-align: center;
    }
    .text-add-contacts {
      color: ${colors.black};
      font-family: MTTMilano-Medium, sans-serif;
      font-size: 20px;
      letter-spacing: 0;
      line-height: 19px;
      margin-bottom: 15px;
    }
    .select-contacts {
      display: flex;
      flex-direction: column;
      margin-top: 10px;
      gap: 10px;
    }
    .switch-section {
      display: flex;
    }
    .contacts-access-status {
      color: ${colors.black};
      font-family: MTTMilano-Medium, sans-serif;
      font-size: 14px;
      letter-spacing: 0;
      line-height: 19px;
    }
    .switch-label {
      color: ${colors.black};
      font-family: MTTMilano-Medium, sans-serif;
      font-size: 14px;
      letter-spacing: 0;
      line-height: 19px;
      padding: 10px 0;
    }
    .contacts-box {
      height: 180px;
      width: 397px;
      border: 1px solid ${colors.pattens};
      border-radius: 4px;
      margin-bottom: 18px;
      overflow: auto;
    }
    .contacts-container {
      display: grid;
      grid-template-columns: repeat(2, max-content);
      list-style-type: none;
    }
    .share-contacts-container {
      display: grid;
      grid-template-columns: repeat(3, max-content);
      list-style-type: none;
    }
    .list-contact {
      color: ${colors.zambezi};
      font-family: ${fonts.roboto};
      font-size: 13px;
      letter-spacing: 0;
      line-height: 25px;
      padding-right: 40px;
      display: flex;
    }
    .share-list-contact {
      width: 205px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .button {
      height: 28px;
      width: 111px;
      font-size: 14px;
    }
    .empty-data-container {
      display: flex;
      flex-direction: column;
      margin-top: 5px;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 80%;
      svg {
        fill: ${colors.suvaGrey};
        height: 65px;
        width: 57px;
        margin-bottom: 13px;
      }
      span {
        color: ${colors.suvaGrey};
        font-family: ${fonts.default};
        font-size: ${fontSizes.sm}px;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 16px;
      }
    }

    @media (max-width: 992px) {
      .button-section {
        flex-direction: column;
        align-items: center;
        gap: 10px;
      }
      .statistic-section {
        flex-direction: column;
        align-items: center;
      }
    }

    @media ${device.sm} {
      .contacts-box {
        width: 100%;
      }
      .contacts-container {
        column-count: 1;
        padding-top: 20px;
        list-style-type: none;
        margin-left: 0;
      }
    }
  }
`;

const AddFormModal = styled(Modal)`
  top: 14%;
  height: auto;
  .modal-content {
    border-radius: 4px;
    padding: 30px 22.5px 30px 22.5px;
    height: auto;
  }
  .title-wrapper {
    border-bottom: 1px solid ${colors.black};
    padding-bottom: 15px;
    margin-bottom: 23.5px;
    width: 100%;
  }
  .title {
    color: ${colors.black};
    font-family: ${fonts.default};
    font-size: ${fontSizes.xlg}px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 24px;
  }
  .modal-header {
    border: 0;
    height: 11px;
    padding-top: 0px;
    padding-bottom: 0;
    padding-right: 0px;

    svg {
      fill: ${colors.suvaGrey} !important;
      height: 18px !important;
      width: 18px !important;
    }
  }
  .modal-body {
    padding: 0;
  }
`;

export {
  NavHome,
  NavLink,
  UploadedImage,
  CustomCollapse,
  CustomCollapseBody,
  OptionMenu,
  TableHeader,
  TableHeaderText,
  Popover,
  GroupFieldWrapper,
  PopoverSort,
  Information,
  InformationModal,
  ContactsModal,
  AddFormModal,
};
